import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const err = (e, fb) => { const d = e?.response?.data?.detail; return Array.isArray(d) ? d[0]?.msg : d || fb; };

export function RecordLodgedDialog({ jobId, enquiry, open, onOpenChange, onDone }) {
  const [ref, setRef] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/jobs/${jobId}/underground-enquiries/${enquiry.id}/requested`,
        { reference: ref, lodged_on: date, confirm_lodged_on_beforeudig: confirm }, { __flOnlineOnly: true });
      toast.success("Enquiry recorded as lodged");
      onDone(data); onOpenChange(false);
    } catch (e) { toast.error(err(e, "Could not record the enquiry")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setConfirm(false); setRef(""); } onOpenChange(o); }}>
      <DialogContent className="max-w-md" data-testid="bud-lodged-dialog">
        <DialogHeader>
          <DialogTitle>Record beforeUdig enquiry</DialogTitle>
          <DialogDescription>Fieldlink doesn't send this to beforeUdig for you yet. Lodge it on beforeudig.co.nz first, then enter the reference number they gave you.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <label className="block text-sm font-medium">beforeUdig reference number<Input value={ref} onChange={(e) => setRef(e.target.value)} maxLength={40} className="mt-1 h-11" data-testid="bud-reference-input" /></label>
          <label className="block text-sm font-medium">Lodged on<input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1 h-11 w-full rounded-md border border-border bg-background px-3 text-sm" data-testid="bud-lodged-date" /></label>
          <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} className="mt-1 accent-[#FF5F15]" data-testid="bud-lodged-confirm" />I've lodged this enquiry on beforeUdig and the reference above is theirs.</label>
          <Button onClick={submit} disabled={busy || !confirm || ref.trim().length < 3} className="w-full bg-[#FF5F15] hover:bg-[#E65100] text-white" data-testid="bud-lodged-submit">{busy ? "Saving…" : "Record as lodged"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function ReviewDialog({ jobId, enquiry, open, onOpenChange, onDone }) {
  const [ack, setAck] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/jobs/${jobId}/underground-enquiries/${enquiry.id}/status`, { status: "reviewed", note, acknowledge_safety: ack }, { __flOnlineOnly: true });
      toast.success("Plans marked as reviewed");
      onDone(data); onOpenChange(false);
    } catch (e) { toast.error(err(e, "Could not save the review")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setAck(false); setNote(""); } onOpenChange(o); }}>
      <DialogContent className="max-w-md" data-testid="bud-review-dialog">
        <DialogHeader>
          <DialogTitle>Mark plans as reviewed</DialogTitle>
          <DialogDescription>This only records that someone reviewed the plans. It does not mean there are no services, or that it's safe to dig.</DialogDescription>
        </DialogHeader>
        <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} maxLength={1000} placeholder="Review notes, e.g. power cable along the berm, locator booked for Tuesday" className="w-full rounded-md border border-border bg-background p-3 text-sm" data-testid="bud-review-note" />
        <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={ack} onChange={(e) => setAck(e.target.checked)} className="mt-1 accent-[#FF5F15]" data-testid="bud-review-ack" />I've reviewed every plan and response. Services will still be located and marked on site, and safe excavation procedures followed, before digging.</label>
        <Button onClick={submit} disabled={busy || !ack} className="w-full bg-[#FF5F15] hover:bg-[#E65100] text-white" data-testid="bud-review-submit">{busy ? "Saving…" : "Mark as reviewed"}</Button>
      </DialogContent>
    </Dialog>
  );
}
